import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { MissionSummary } from '@edwin-group/cj-graphql';

export const MissionFilter = ({
  missionSummary,
  missionSelected,
  setMissionSelected,
}: {
  missionSummary: MissionSummary;
  missionSelected: string | null;
  setMissionSelected: (mission: string) => void;
}) => {
  const page = useReportingToolsStore((state) => state.page);

  return (
    <div className="mt-sh-15 max-w-96">
      <label className="text-sh-xxs font-bold" htmlFor="mission-filter">
        {page?.missionSummary?.filter.mission}
      </label>
      <Select
        onValueChange={(option) => {
          setMissionSelected(option);
        }}
        value={missionSelected || ''}>
        <SelectTrigger>
          <SelectValue placeholder={page?.missionSummary?.filter.missionPlaceholder} />
        </SelectTrigger>
        <SelectContent>
          {missionSummary?.missions?.map((option) => {
            return (
              <SelectItem key={option?.roleModel} value={option?.roleModel || ''}>
                {option?.roleModel}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};
